interface SetResult {
  home: number
  away: number
}

interface Props {
  history: SetResult[]
  maxSets?: number
  className?: string
}

export default function SetHistory({ history, maxSets = 5, className = '' }: Props) {
  if (history.length === 0) return null

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {history.map((set, i) => {
        const homeWon = set.home > set.away
        return (
          <div key={i} className="flex flex-col items-center gap-0.5">
            <span className={`font-display font-bold text-xs tabular-nums leading-none ${
              homeWon ? 'text-white' : 'text-white/40'
            }`}>
              {set.home}
            </span>
            <span className="text-white/20 text-[10px]">·</span>
            <span className={`font-display font-bold text-xs tabular-nums leading-none ${
              !homeWon ? 'text-white' : 'text-white/40'
            }`}>
              {set.away}
            </span>
          </div>
        )
      })}
      {/* Slot vuoti per set futuri */}
      {Array.from({ length: Math.max(0, maxSets - history.length) }, (_, i) => (
        <div key={`empty-${i}`} className="flex flex-col items-center gap-0.5 opacity-20">
          <span className="font-display text-xs text-white/30">–</span>
          <span className="text-white/10 text-[10px]">·</span>
          <span className="font-display text-xs text-white/30">–</span>
        </div>
      ))}
    </div>
  )
}
